import { render } from "./DownloadHealthFolderView.vue?vue&type=template&id=d90df0d8&ts=true"
import script from "./DownloadHealthFolderView.vue?vue&type=script&lang=ts"
export * from "./DownloadHealthFolderView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__